import {defineStore} from "pinia";
import GroupAPI from "@/api/GroupAPI";

export const useGroupStore = defineStore('group', {
  state: () => ({
    data: [],
  }),
  actions: {
    clear() {
      this.data = [];
    },
    find(id) {
      return this.data.find(data => parseInt(data.id) === parseInt(id)) || null;
    },
    index(payload) {
      const { params } = payload;

      return new GroupAPI().index(params)
      .then((response) => {
        this.data = response.data;
        return response;
      });
    },
    store(payload) {
      return new GroupAPI().store(payload)
        .then((response) => {
          return response;
        });
    },
  },
  persist: true,
});
